var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3.8,
    y1: -1568.39,
    x2: 3.8,
    y2: -1418.95,
    gradientTransform: "matrix(1, 0, 0, -1, 104.81, -1395.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 3.94,
    y1: -1426.38,
    x2: 3.94,
    y2: -1413.72,
    gradientTransform: "matrix(1, 0, 0, -1, 89.36, -1393.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.93,
    y1: -1416.31,
    x2: 3.93,
    y2: -1401.35,
    gradientTransform: "matrix(0.98, -0.21, -0.21, -0.98, -208.46, -1361.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 141.99,
    y1: -1722,
    x2: 141.99,
    y2: -1572.56,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -1540)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 142.12,
    y1: -1579.99,
    x2: 142.12,
    y2: -1567.33,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -1540)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 332.04,
    y1: -1629.52,
    x2: 332.04,
    y2: -1614.55,
    gradientTransform: "matrix(1, 0, 0, -1, -189.92, -1599.59)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gfx-no-data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250,119.17a39.46,39.46,0,0,1-5.71,20.52A25.78,25.78,0,0,1,235,159.11a31.63,31.63,0,0,1-4.61,3.34l-.2.12-.37.22-.12.07h0c-.52.29-1.06.58-1.6.85A36.2,36.2,0,0,1,212,167.42H47.46q-2,0-3.9-.16a46.14,46.14,0,0,1-13.34-3.09q-1.25-.49-2.45-1.06l-1.13-.55-.7-.36a41.62,41.62,0,0,1-4.08-2.48,40.17,40.17,0,0,1-3.45-2.65c-7.44-6.38-12-15.21-12-25A39.44,39.44,0,0,1,0,110.54C0,88.88,17.32,71.31,38.68,71.31c.66,0,1.31,0,2,.05h.28a66.64,66.64,0,0,1,14.2-16.74C70.92,41.11,94,32.58,119.69,32.58c21.6,0,41.34,6,56.46,16a38.06,38.06,0,0,1,18.78-4.93c21.36,0,38.68,17.56,38.68,39.23a40.39,40.39,0,0,1-.22,4.1A39.34,39.34,0,0,1,250,119.17Z",
    style: {
      fill: "#6c63ff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.64,
    y: 21.24,
    width: 111.94,
    height: 154.67,
    transform: "translate(-18.26 24.98) rotate(-12.11)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.53,
    y: 23.86,
    width: 108.16,
    height: 149.44,
    transform: "translate(-18.26 24.98) rotate(-12.11)",
    style: {
      fill: "url(#linear-gradient)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 55.79,
    y: 24.97,
    width: 105.4,
    height: 146.14,
    transform: "translate(-18.15 24.94) rotate(-12.11)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.16,
    y: 20.23,
    width: 52.29,
    height: 12.67,
    transform: "translate(-3.5 20.16) rotate(-12.11)",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.38,8.28a7.4,7.4,0,0,0-5.58,8.85,7.31,7.31,0,1,0,5.58-8.85Zm2.48,11.55a4.32,4.32,0,1,1,3.2-5.2l0,.08a4.27,4.27,0,0,1-3.2,5.12Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.54,
    y: 19.71,
    width: 51.19,
    height: 12.11,
    transform: "translate(-3.33 20.11) rotate(-12.11)",
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.38,8.28a7.15,7.15,0,1,0,8.5,5.49,7.15,7.15,0,0,0-8.5-5.49Zm2.37,11a4.13,4.13,0,1,1,3.17-4.9h0A4.13,4.13,0,0,1,91.74,19.32Z",
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.02,
    y: 29.95,
    width: 111.94,
    height: 154.67,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.91,
    y: 32.56,
    width: 108.16,
    height: 149.44,
    style: {
      fill: "url(#linear-gradient-4)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.28,
    y: 33.66,
    width: 105.4,
    height: 146.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.98,
    y: 27.33,
    width: 52.29,
    height: 12.67,
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.12,15a7.49,7.49,0,1,0,7.31,7.48A7.4,7.4,0,0,0,142.12,15Zm0,11.8a4.32,4.32,0,1,1,4.21-4.42s0,.07,0,.1a4.27,4.27,0,0,1-4.22,4.3Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.53,
    y: 26.78,
    width: 51.19,
    height: 12.11,
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.12,15a7.15,7.15,0,1,0,7.15,7.15h0A7.15,7.15,0,0,0,142.12,15Zm0,11.28a4.13,4.13,0,1,1,4.13-4.14,4.13,4.13,0,0,1-4.13,4.14h0Z",
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.87,
    y: 188.79,
    width: 0.96,
    height: 5.46,
    style: {
      fill: "#47e6b1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.62,
    y: 191.04,
    width: 5.46,
    height: 0.96,
    style: {
      fill: "#47e6b1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.61,
    width: 0.96,
    height: 5.46,
    style: {
      fill: "#47e6b1"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.36,
    y: 2.25,
    width: 5.46,
    height: 0.96,
    style: {
      fill: "#47e6b1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.47,197.89a1.18,1.18,0,0,1-.66-1.43.57.57,0,0,0,0-.13h0a.59.59,0,0,0-1.06-.39h0a.57.57,0,0,0-.07.12,1.18,1.18,0,0,1-1.43.66l-.13,0h0a.59.59,0,0,0-.39,1.06h0l.12.07a1.18,1.18,0,0,1,.66,1.43.57.57,0,0,0,0,.13h0a.59.59,0,0,0,1.06.39h0a.57.57,0,0,0,.07-.12,1.18,1.18,0,0,1,1.43-.66l.13,0h0a.59.59,0,0,0,.39-1.06h0Z",
    style: {
      fill: "#4d8af0",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,145.36a1.18,1.18,0,0,1-.66-1.43.57.57,0,0,0,0-.13h0a.59.59,0,0,0-1.06-.39h0a.57.57,0,0,0-.07.12,1.18,1.18,0,0,1-1.43.66l-.13,0h0a.59.59,0,0,0-.39,1.06h0l.12.07a1.18,1.18,0,0,1,.66,1.43.57.57,0,0,0,0,.13h0a.59.59,0,0,0,1.06.39h0a.57.57,0,0,0,.07-.12,1.18,1.18,0,0,1,1.43-.66l.13,0h0a.59.59,0,0,0,.39-1.06h0Z",
    style: {
      fill: "#fdd835",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.32,17.46a1.18,1.18,0,0,1-.66-1.43.57.57,0,0,0,0-.13h0a.59.59,0,0,0-1.06-.39h0a.57.57,0,0,0-.07.12,1.18,1.18,0,0,1-1.43.66l-.13,0h0a.59.59,0,0,0-.39,1.06h0l.12.07a1.18,1.18,0,0,1,.66,1.43.57.57,0,0,0,0,.13h0a.59.59,0,0,0,1.06.39h0a.57.57,0,0,0,.07-.12,1.18,1.18,0,0,1,1.43-.66l.13,0h0a.59.59,0,0,0,.39-1.06h0Z",
    style: {
      fill: "#fdd835",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.11,
    cy: 80.55,
    r: 1.93,
    style: {
      fill: "#f55f44",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.06,
    cy: 191.25,
    r: 1.93,
    style: {
      fill: "#f55f44",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.3,
    cy: 122.24,
    r: 1.93,
    style: {
      fill: "#f55f44",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.28,
    cy: 24.68,
    r: 1.93,
    style: {
      fill: "#4d8af0",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.89,
    cy: 77.29,
    r: 1.93,
    style: {
      fill: "#47e6b1",
      opacity: 0.5,
      isolation: "isolate"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxNoData);
export default __webpack_public_path__ + "static/media/gfx-no-data.39a56df9ae2e248881d938476727d26f.svg";
export { ForwardRef as ReactComponent };